import React, { useEffect, useRef } from "react";
import { Switch, Redirect } from "react-router-dom";

// state
import { connect } from "react-redux";

// utils
import lazy from "utils/lazy";

// components
import AuthGuard from "auth-guard/index";
import Login from "components/login/Login";
import HFNAuth from "components/hfnauth";
import AccessDenied from "shared-components/logout/AccessDenied";

// shared components
import HFNErrorBoundary from "shared-components/errorBoundary";
import HFNLoader from "shared-components/lazyLoading";
import HFNToaster from "shared-components/toasters";
import HFNConfirmDialog from "shared-components/confirmDialog";
import TokenExpire from "shared-components/logout/tokenExpire";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { isLoginAuth, logout } from "utils/common";
import { lStorage } from "utils/storage";
import config from "assets/config";

// lazy components
const LayoutContainer = lazy("layouts/Template");

const App = () => {
  const history = useHistory();
  const elementRef = useRef(null);
  const { pathname } = useLocation();
  useEffect(() => {
    if (
      isLoginAuth() &&
      (pathname.includes("hfnauth") ||
        pathname.includes("login") ||
        pathname.includes("unauthorized"))
    ) {
      const { role } = lStorage.get("authInfo") || {};
      if (role) {
        history.push("/template/listing");
      } else {
        history.push("/unauthorized");
      }
    }
  }, [history]);
  useEffect(() => {
    import("hfnauth/main");
  });
  const handleUserLoggedOut = async (event) => {
    if (event?.detail?.loggedOut) {
      await logout();
    }
  };
  useEffect(() => {
    elementRef.current = document.querySelector("hfn-auth");
    if (elementRef.current) {
      elementRef.current.addEventListener("userLoggedOut", handleUserLoggedOut);
    }
    return () => {
      if (elementRef.current) {
        elementRef.current.removeEventListener(
          "userLoggedOut",
          handleUserLoggedOut
        );
      }
    };
  }, [elementRef]);
  return (
    <HFNErrorBoundary>
      <HFNLoader>
        <hfn-auth
          ref={elementRef}
          config={JSON.stringify(config?.keyCloakAuthConfig)}
          showCancel
          authType={
            window.location.pathname !== "/unauthorized" ? "" : "on-demand"
          }
        />
        <div className="hfn">
          <Switch>
            <Login path="/login" />
            <HFNAuth path="/hfnauth/authorization" />
            <AccessDenied path="/unauthorized" />
            <AuthGuard path="/" component={LayoutContainer} />
            <Redirect to="/login" />
          </Switch>
        </div>
        <div>
          <HFNToaster />
          <HFNConfirmDialog />
          <TokenExpire />
        </div>
      </HFNLoader>
    </HFNErrorBoundary>
  );
};

const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});

export default connect(mapStateToProps)(App);
